/*
  MFT videos: the little bit of script behind every video on the site.

  1. Players. A video shows as its YouTube thumbnail with a play button until
     someone clicks it. Only then does the YouTube player load, so the Videos
     page with fifteen videos on it loads about as fast as fifteen photos.
  2. The pop-up player. The small video cards (product, collection and content
     pages, and the homepage side list) play in a pop-up, so the page under it
     doesn't jump and nobody loses their place in a product listing.
  3. Thumbnails. YouTube's big thumbnail doesn't exist for every video. If it
     comes back as YouTube's tiny grey stand-in, swap to one that does.
  4. The Videos page: the topic buttons and the "Read the full description"
     toggles, plus opening the right video up when someone arrives on a link
     like /pages/videos#best-kept-secret-to-grow-in-a-cold-climate.

  Every link still works with no script at all: it just goes to YouTube.
  Loaded by the mft-video-assets snippet. Safe to include more than once.
*/
(function () {
  if (window.__mftVideos) return;
  window.__mftVideos = true;

  var EMBED = 'https://www.youtube-nocookie.com/embed/';

  function makeFrame(id, title) {
    var f = document.createElement('iframe');
    f.src = EMBED + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1';
    f.title = title || 'YouTube video';
    f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return f;
  }

  /* 1. Play in place */
  function playInPlace(link) {
    var box = link.closest('[data-mftv-player]');
    if (!box || box.classList.contains('is-playing')) return;
    box.classList.add('is-playing');
    var frame = makeFrame(link.getAttribute('data-mftv-id'), link.getAttribute('data-mftv-title'));
    box.appendChild(frame);
    try {
      frame.focus();
    } catch (e) {}
  }

  /* 2. Pop-up player */
  var dialog = null;
  var holder = null;
  var caption = null;
  var opener = null;

  function buildDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'mftv mftv-modal';
    dialog.setAttribute('aria-label', 'Video player');
    dialog.innerHTML =
      '<div class="mftv-modal__box">' +
      '<button type="button" class="mftv-modal__close" aria-label="Close the video">&times;</button>' +
      '<div class="mftv-modal__frame"></div>' +
      '<p class="mftv-modal__title"></p>' +
      '</div>';
    document.body.appendChild(dialog);
    holder = dialog.querySelector('.mftv-modal__frame');
    caption = dialog.querySelector('.mftv-modal__title');
    dialog.querySelector('.mftv-modal__close').addEventListener('click', closePopup);
    // A click on the dark backdrop lands on the dialog itself, not the box.
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closePopup();
    });
    // Esc closes a dialog on its own; empty the frame on the way out.
    dialog.addEventListener('cancel', function () {
      holder.innerHTML = '';
    });
    dialog.addEventListener('close', function () {
      holder.innerHTML = '';
    });
    return dialog;
  }

  // Emptying the frame is what actually stops the sound, so it happens here
  // straight away rather than waiting on the dialog's own close event.
  function closePopup() {
    if (!dialog) return;
    holder.innerHTML = '';
    if (dialog.open) dialog.close();
    if (opener) {
      try {
        opener.focus();
      } catch (e) {}
    }
  }

  function openPopup(link) {
    var d = buildDialog();
    if (typeof d.showModal !== 'function') return false;
    opener = link;
    holder.innerHTML = '';
    holder.appendChild(makeFrame(link.getAttribute('data-mftv-id'), link.getAttribute('data-mftv-title')));
    caption.textContent = link.getAttribute('data-mftv-title') || '';
    d.showModal();
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var inPlace = e.target.closest('[data-mftv-play]');
    if (inPlace) {
      e.preventDefault();
      playInPlace(inPlace);
      return;
    }
    var popup = e.target.closest('[data-mftv-modal]');
    if (popup && openPopup(popup)) {
      e.preventDefault();
    }
  });

  /* 3. Thumbnails */
  function fixThumb(img) {
    if (img.getAttribute('data-mftv-done')) return;
    img.setAttribute('data-mftv-done', '1');
    function swap() {
      var fallback = img.getAttribute('data-mftv-fallback');
      if (fallback && img.currentSrc !== fallback) {
        img.removeAttribute('srcset');
        img.src = fallback;
      }
    }
    // naturalWidth on an img with a srcset is scaled to the size it's shown
    // at, so a small card could look like the stand-in. Load the same file
    // into a bare Image (it's already cached) to see its real width.
    function check() {
      var probe = new Image();
      probe.onload = function () {
        if (probe.naturalWidth && probe.naturalWidth <= 120) swap();
      };
      probe.src = img.currentSrc || img.src;
    }
    if (img.complete) {
      check();
    } else {
      img.addEventListener('load', check, { once: true });
      img.addEventListener('error', swap, { once: true });
    }
  }

  /* 4. The Videos page */
  function setUpLibrary(root) {
    if (root.__mftvReady) return;
    root.__mftvReady = true;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-mftv-topic]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-mftv-item]'));
    var status = root.querySelector('[data-mftv-status]');

    function show(topic) {
      var count = 0;
      items.forEach(function (item) {
        var match = topic === 'all' || item.getAttribute('data-topic') === topic;
        item.hidden = !match;
        if (match) count++;
      });
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mftv-topic') === topic ? 'true' : 'false');
      });
      if (status) status.textContent = count === 1 ? 'Showing 1 video' : 'Showing ' + count + ' videos';
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        show(b.getAttribute('data-mftv-topic'));
      });
    });

    root.querySelectorAll('[data-mftv-more]').forEach(function (btn) {
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (!body) return;
      btn.addEventListener('click', function () {
        var open = body.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });

    // Arriving from a product page on /pages/videos#<handle>: make sure that
    // video isn't filtered out, open its description, and bring it into view.
    function arrive() {
      var id = '';
      try {
        id = decodeURIComponent((window.location.hash || '').slice(1));
      } catch (e) {}
      if (!id) return;
      var target = document.getElementById(id);
      if (!target || !root.contains(target) || !target.hasAttribute('data-mftv-item')) return;
      if (target.hidden) show('all');
      target.classList.add('is-shown');
      var more = target.querySelector('[data-mftv-more]');
      if (more && more.getAttribute('aria-expanded') !== 'true') more.click();
      setTimeout(function () {
        target.scrollIntoView({ block: 'start' });
      }, 60);
    }
    arrive();
    window.addEventListener('hashchange', arrive);
  }

  function scan() {
    document.querySelectorAll('img[data-mftv-fallback]').forEach(fixThumb);
    document.querySelectorAll('[data-mftv-library]').forEach(setUpLibrary);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();